import React from "react";
import { MetaPixel } from "./components/MetaPixel";
import { HeroSection } from "./components/sections/HeroSection";
import { StorySection } from "./components/sections/StorySection";
import { ProblemsSection } from "./components/sections/ProblemsSection";
import { VolumesSection } from "./components/sections/VolumesSection";
import { ToolsSection } from "./components/sections/ToolsSection";
import { BonusesSection } from "./components/sections/BonusesSection";
import { OfferSection } from "./components/sections/OfferSection";
import { GuaranteeSection } from "./components/sections/GuaranteeSection";
import { BeforeAfterSection } from "./components/sections/BeforeAfterSection";
import { MessageSection } from "./components/sections/MessageSection";
import { TestimonialsSection } from "./components/sections/TestimonialsSection";
import { AuthorSection } from "./components/sections/AuthorSection";
import { FaqSection } from "./components/sections/FaqSection";
import { FinalCtaSection } from "./components/sections/FinalCtaSection";
import { Footer } from "./components/Footer";
import { FloatingCta } from "./components/FloatingCta";
import { PurchasePopup } from "./components/PurchasePopup";
export function App() {
  return <div className="w-full min-h-full overflow-x-hidden bg-cream font-sans text-ink" data-id="element-0" data-mp="3rd1a7k1rbfok">
      <MetaPixel data-id="element-1" data-mp="5gel8p3rovc" />
      <HeroSection data-id="element-2" data-mp="82ld64660ci" />
      <main data-id="element-3" data-mp="2zl3azit8d249">
        <StorySection data-id="element-4" data-mp="2zld4hgdhhrep" />
        <ProblemsSection data-id="element-5" data-mp="2zm4zaoz9bl3x" />
        <VolumesSection data-id="element-6" data-mp="2zmwi0z7r9ocs" />
        <ToolsSection data-id="element-7" data-mp="2znfyebhrc4op" />
        <BonusesSection data-id="element-8" data-mp="33m5a7zn5de68" />
        <OfferSection data-id="element-9" data-mp="33nges1of2pye" />
        <GuaranteeSection data-id="element-10" data-mp="33mykvbp88ntn" />
        <BeforeAfterSection data-id="element-11" data-mp="38lrq6gud18iq" />
        <MessageSection data-id="element-12" data-mp="38li7lebna3n2" />
        <TestimonialsSection data-id="element-13" data-mp="38k6ugnwb7jja" />
        <AuthorSection data-id="element-14" data-mp="38o4ercumih4r" />
        <FaqSection data-id="element-15" data-mp="3dle1ulujigpf" />
        <FinalCtaSection data-id="element-16" data-mp="3dlw5w4ng1z7w" />
      </main>
      <Footer data-id="element-17" data-mp="3dirtwl3qlz6o" />
      <FloatingCta data-id="element-18" data-mp="nvj4bi5joiqs" />
      <PurchasePopup data-id="element-19" data-mp="nw2a60hx7gog" />
    </div>;
}